<template>
<!--分页-->
<div class="page-content mt-40">
  <div class="page-total">共{{totalRow}}个事项</div>
  <div class="page-btns">
    <a href="javascript://" :class="['page-pre', {'dis-btn': pageIndex == 1}]" @click="changePage('pre')">
      <i class="el-icon-arrow-left"></i>
    </a>
    <p class="page-count">
      <el-input type="text" v-model="pageIndexInput" :disabled="totalPage == 1"></el-input>
    </p>
    <span>/{{totalPage}}</span>
    <a href="javascript://" :class="['page-jump', {'dis-btn': totalPage == 1}]" @click="changePage('jump')">跳转</a>
    <a href="javascript://" :class="['page-next', {'dis-btn': pageIndex == totalPage}]" @click="changePage('next')">
      <i class="el-icon-arrow-right"></i>
    </a>
  </div>
</div>
<!--end-->
</template>

<script>
export default {
  props: {
    'pageIndex': {
      type: String | Number
    },
    'linktoPageCall': {
      type: Function,
      required: true
    },
    'totalPage': {
      type: String | Number
    },
    'totalRow': {
      type: String | Number
    },
  },
  data() {
    return {
      pageIndexInput: 1,
    }
  },
  methods: {
    changePage(type) {
      if (type == 'pre') {
        if (+this.pageIndexInput == 1) { //第一页不能往前
          return false;
        } else {
          this.pageIndexInput = +this.pageIndexInput - 1;
          this.linktoPageCall(this.pageIndexInput)
        }
      } else if (type == 'next') {
        if (+this.pageIndexInput == +this.totalPage) { //最后一页不能往后
          return false;
        } else {
          this.pageIndexInput = +this.pageIndexInput + 1;
          this.linktoPageCall(this.pageIndexInput)
        }
      } else {
        if (+this.pageIndexInput > +this.totalPage || +this.pageIndexInput < 1) {
          return false;
        } else {
          this.linktoPageCall(this.pageIndexInput)
        }
      }
    },
  },
  watch:{
    pageIndexInput(val){
      if(parseInt(val) < 1){
        this.pageIndexInput = 1;
      }
      if(parseInt(pageIndexInput) > parseInt(this.pageIndex)){
        this.pageIndexInput = this.pageIndex
      }
      console.log("watach", pageIndexInput, this.pageIndexInput)
    }
  },
  mounted() {}
}
</script>

<style lang="scss">
.page-content {
  width: 100%;

  p {
    display: inline-block;
  }

  .page-total {
    text-align: left;
    color: #727475;
    margin-bottom: 24px;
  }

  .dis-btn {
    cursor: no-drop !important;
  }

  .page-btns {
    text-align: left;
    font-size: 14px;
    color: #777777;
    line-height: 38px;

    .page-pre {
      display: inline-block;
      width: 38px;
      height: 38px;
      background: #EBF4FB;
      border: 1px solid #EBF4FB;
      cursor: pointer;
      text-align: center;

      i {
        color: #3E97DF;
      }
    }

    .page-next {
      width: 38px;
      height: 38px;
      background: #3E97DF;
      border: 1px solid #3E97DF;
      text-align: center;

      i {
        color: #FFFFFF;
      }
    }

    .page-count {
      margin: 0 10px;
      width: 80px;
      height: 38px;
      background: #FFFFFF;

      .el-input__inner {
        border-radius: 0;
        padding: 0;
        text-align: center;
        border: 1px solid #DFE1E2;
        color: #112534;
      }
    }

    .page-jump {
      width: 70px;
      height: 38px;
      background: rgba(62, 151, 223, 0.10);
      border: 1px solid rgba(62, 151, 223, 0.10);
      color: #3E97DF;
      margin: 0 10px;
      text-align: center;
    }
  }
}
</style>
